// extracted by mini-css-extract-plugin
export default {"tab":"Accordion_tab__m1N6B","iconWrapper":"Accordion_iconWrapper__lrprv","content":"Accordion_content__dS6MQ"};